export default "__VITE_ASSET__80f15c82__"